import { Anchor } from '../../components';
import { ReactComponent as Twitter } from '../../assets/icons/twitter.svg';
import { ReactComponent as Linkedin } from '../../assets/icons/linkedin.svg';
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as Envelope } from '../../assets/icons/envelope-open.svg';

const readVal = (val) => {
    if (typeof val === 'function') return val();
    return val;
};

const ShareLinks = ({ shareText, shareLink }) => {
    const url = readVal(shareLink);
    const text = readVal(shareText);

    return (
        <>
            <span style={{ marginTop: '20px' }}>Please share with your friends</span>
            <ul className="social-icons-container" style={{ margin: 0 }}>
                <li>
                    <Anchor href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
                        <Facebook height="22px" fill="var(--cademy-blue)" />
                    </Anchor>
                </li>
                <li>
                    <Anchor href={`https://twitter.com/intent/tweet?url=${url}&text=${text}`}>
                        <Twitter height="22px" fill="var(--cademy-blue)" />
                    </Anchor>
                </li>
                <li>
                    <Anchor
                        href={`http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${text}`}
                    >
                        <Linkedin height="22px" fill="var(--cademy-blue)" />
                    </Anchor>
                </li>
                <li>
                    <Anchor href={`mailto:?body=${url}&subject=${text}`}>
                        <Envelope height="22px" fill="var(--cademy-blue)" />
                    </Anchor>
                </li>
            </ul>
        </>
    );
};

export default ShareLinks;
